import { render, staticRenderFns } from "./Sfa.vue?vue&type=template&id=05e2fbbb&scoped=true&"
import script from "./Sfa.vue?vue&type=script&lang=js&"
export * from "./Sfa.vue?vue&type=script&lang=js&"
import style0 from "./Sfa.vue?vue&type=style&index=0&id=05e2fbbb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2fbbb",
  null
  
)

export default component.exports